import { createSlice } from '@reduxjs/toolkit';

import { TOOLS_REDUCER_NAMES } from '../constants';

import {
  CommonState,
  CommonTool,
  SetCommonToolAction,
  SetConverterPositionAction,
  UpdateCommonToolAction,
} from './types';

const initialState: CommonState = {
  commonTool: null,
  converterPosition: null,
};

const commonSlice = createSlice({
  name: TOOLS_REDUCER_NAMES.COMMON,
  initialState: initialState,
  reducers: {
    setCommonTool(state, action: SetCommonToolAction) {
      state.commonTool = action.payload;
    },
    updateCommonTool(state, action: UpdateCommonToolAction) {
      if (!state.commonTool) {
        return;
      }

      const updatedValue = {
        ...state.commonTool.value,
        ...action.payload,
      } as CommonTool['value'];

      state.commonTool = {
        ...state.commonTool,
        value: updatedValue,
      } as CommonTool;
    },
    setConverterPosition(state, action: SetConverterPositionAction) {
      state.converterPosition = action.payload;
    },
  },
  extraReducers: (builder) => builder,
});

export const { actions: commonActions, reducer: commonReducer } = commonSlice;
